import { onlineClassesUrl } from "@outschool/routes";
import { TrackingPage } from "@outschool/ui-legacy-component-library";
import React from "react";
import { useLocation } from "react-router";

import {
  useOnlineClassesPageDescription,
  useOnlineClassesPageTitle,
} from "../../../hooks/PageMetaDataHooks";
import { useCategoryPageQuery } from "../../../hooks/useCategoryPageQuery";
import { useCuratedCategoryPageQuery } from "../../../hooks/useCuratedCategoryPageQuery";
import HeaderTags from "../../HeaderTags";
import SimpleLayout, { SimpleLayoutProps } from "../../layouts/SimpleLayout";
import { DefaultErrorBoundaryMessage } from "../../SimpleErrorBoundary";
import { PageLoading } from "../curated/CuratedCategoryPage";
import CuratedPageBody from "../curated/CuratedPageBody";

export default function CatalogHubPage() {
  const metaTitle = useOnlineClassesPageTitle();
  const metaDescription = useOnlineClassesPageDescription();
  const metaTags = [
    { name: "description", content: metaDescription },
    { property: "og:title", content: metaTitle },
    { property: "og:description", content: metaDescription },
  ];
  const link = [{ rel: "canonical", href: onlineClassesUrl() }];

  const categorySlug = "root";
  const fetchContentfulPreview = !!useLocation().query["preview"];

  const curatedCategoryPageQueryResult = useCuratedCategoryPageQuery({
    categorySlug,
    preview: fetchContentfulPreview,
  });
  const taxonomyQueryResult = useCategoryPageQuery("popular");

  const isLoading =
    curatedCategoryPageQueryResult.loading || taxonomyQueryResult.loading;

  if (curatedCategoryPageQueryResult.error || taxonomyQueryResult.error) {
    return <DefaultErrorBoundaryMessage />;
  }
  const layoutProps: Partial<SimpleLayoutProps> = {
    allowCategoriesNavbar: true,
  };
  return (
    <TrackingPage name="Root" uniqueId="catalogHub">
      {setImpressionNode => (
        <SimpleLayout
          hideReviewReminder
          // @ts-ignore TS(2345): Argument of type 'HTMLDivElement | null' is not as... Remove this comment to see the full error message
          ref={node => setImpressionNode(node)}
          {...layoutProps}
        >
          <HeaderTags title={metaTitle} meta={metaTags} link={link} />

          {isLoading ? (
            <PageLoading loading={isLoading} />
          ) : (
            <CuratedPageBody
              // @ts-ignore TS(2345): Argument of type 'HTMLDivElement | null' is not as... Remove this comment to see the full error message
              ref={node => setImpressionNode(node)}
              categorySlug={categorySlug}
              curatedCategoryPageQueryResult={curatedCategoryPageQueryResult}
              taxonomyQueryResult={taxonomyQueryResult}
              preview={fetchContentfulPreview}
            />
          )}
        </SimpleLayout>
      )}
    </TrackingPage>
  );
}
